import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Pets as PetsIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import AppStyles from '../styles/AppStyles';

function NoPets() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: 4,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 6,
          borderRadius: 4,
          maxWidth: 600,
          textAlign: 'center',
          backgroundColor: 'white',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 3,
          }}
        >
          <PetsIcon
            sx={{
              fontSize: 80,
              color: AppStyles.colors.primary.main,
              opacity: 0.6,
            }}
          />
        </Box>
        <Typography
          variant="h4"
          sx={{
            color: AppStyles.colors.primary.dark,
            fontWeight: AppStyles.typography.fontWeight.bold,
            marginBottom: 2,
          }}
        >
          {t('noPets.title')}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: AppStyles.colors.text.secondary,
            fontSize: '1.1rem',
            lineHeight: 1.8,
            marginTop: 2,
          }}
        >
          {t('noPets.message')}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: AppStyles.colors.text.secondary,
            fontSize: '0.95rem',
            lineHeight: 1.6,
            marginTop: 3,
            opacity: 0.8,
          }}
        >
          {t('noPets.submessage')}
        </Typography>
      </Paper>
    </Box>
  );
}

export default NoPets;

